import React from 'react';
import * as Internals from './Internals';
import Smartfire from './Smartfire';

if (window) {
  Internals.wordpress();
  Internals.publishSmartfireInScope(Smartfire);
}

export default Smartfire;
export const registerBlock = Smartfire.registerBlock;
/**
 * Create a Smartfire component as a class.
 * @deprecated Prefer to use a Hook instead
 * @type {SmartfireComponent}
 */
export {default as SmartfireComponent} from "./SmartfireComponent";
export const ChildrenBlock = Smartfire.ChildrenBlock;
export const smartProps = Smartfire.smartProps;
export const useEditor = Smartfire.useEditor;
export const useInspectorControl = Smartfire.useInspectorControl;
export const useToolbar = Smartfire.useToolbar;
export const defineBlock = Smartfire.defineBlock;
export const useSmartProp = Smartfire.useSmartProp;
export * from './components';
